import React, { FC } from 'react';
import { Box } from '@mui/material';
import { useStyles } from './NotificationGameIcon.styles';

interface NotificationGameIconProps {
  icon?: string;
}

export const NotificationGameIcon: FC<NotificationGameIconProps> = ({ icon }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <img src={icon} alt="icon" width="32" height="32" />
    </Box>
  );
};
